<template>
  <section class="bg-light " >
    <div class="main-content">
      <router-view/>
    </div>
    <div class="card rounded-0 mb-0 border-right-0 border-left-0 border-bottom-0 bottom-navigation" :class="[hidden, hiddenXS, hiddenSM]" >
      <div class="card-body p-2">
        <div class="d-flex">
          <div class="flex-fill text-center" @click="setMenu('home')">
            <router-link class="no-style"
                         :class="{'menu-text': activeMenu === 'home'}"
                         to="/job-posts">
              <div>
                <i class="fal fa-home-alt fa-lg"></i>
              </div>
              <span class="text-small">หน้าแรก</span>
            </router-link>
          </div>
          <div class="flex-fill text-center" @click="setMenu('saved')">
            <router-link class="no-style"
                         :class="{'menu-text': activeMenu === 'saved'}"
                         :to="jobUser ? '/job-posts?type=saved' : '/job-posts/profile'">
              <div>
                <i class="fal fa-check-circle fa-lg"></i>
              </div>
              <span class="text-small">งานที่ฉันสนใจ</span>
            </router-link>
          </div>
          <div class="flex-fill text-center" @click="setMenu('profile')">
            <router-link class="no-style"
                         :class="{'menu-text': activeMenu === 'profile'}"
                         to="/job-posts/profile">
              <div>
                <i class="fal fa-user-circle fa-lg"></i>
              </div>
              <span class="text-small">บัญชีของฉัน</span>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import axios from 'axios'

export default {
  data () {
    return {
      activeMenu: 'home',
      noFooterPaths: ['/job-posts/user/:id'],
      noFooterSmPaths: ['/job-posts/user/:id']
    }
  },
  computed: {
    ...mapState({
      jobUser: state => state.jobUser.jobUser,
      professional: state => state.jobPost.professional
    }),
    hidden () {
      return {
        'd-none': (this.noFooterPaths.indexOf(this.$route.matched[1].path) > -1)
      }
    },
    hiddenSM () {
      return {
        'd-sm-none d-md-block': (this.noFooterSmPaths.indexOf(this.$route.matched[0].path) > -1)
      }
    },
    hiddenXS () {
      return {
        'd-none d-sm-block': (this.noFooterSmPaths.indexOf(this.$route.matched[0].path) > -1)
      }
    }
  },
  watch: {
    $route (to, from) {
      this.checkCurrentPath(to.path)
    }
  },
  methods: {
    ...mapActions('jobUser', ['updateProfessionalStatus']),
    setMenu (menu) {
      this.activeMenu = menu
    },
    checkCurrentPath (route) {
      // ถ้ามี token query และ professional_id query แนบมาให้ตรวจสอบว่าเป็นแม่บ้านถูกต้องรึเปล่า
      if (route.query.access_token && route.query.professional_id) {
        this.checkAuthProfessional(route.query.access_token, route.query.professional_id)
      } else if (this.professional) {
        // ถ้าเคยมีการ login ผ่าน access token มาแล้วจะมี data professional
        // แล้วถ้าเค้าไม่ได้เข้าผ่าน access_token ให้ลบ job user data ออก
        this.$store.commit('jobUser/SET_JOB_USER', null)
      }

      switch (route.path) {
        case '/job-posts':
          if (!route.query.type) {
            this.setMenu('home')
          } else {
            this.setMenu('saved')
          }
          break
        case '/job-posts/profile':
          this.setMenu('profile')
          break
      }
    },
    fetchAddressProvinces () {
      this.$store.dispatch('addressProvince/LOAD_ADDRESS_PROVINCES')
    },
    async checkAuthProfessional (token, professionalId) {
      const { data } = await axios.post('/professional/' + professionalId + '/me', {
        access_token: token,
        check_job_user: 1
      })
      if (!data.error) {
        this.$store.commit('jobPost/SET_PROFESSIONAL', data.professional)
        if (data.job_user) {
          this.$store.commit('jobUser/SET_JOB_USER', data.job_user)
          if (this.jobUser) {
            await this.fetchJobUserDetail(this.jobUser.id)
          }
        }
      } else {
        this.$swal({ text: data.message, type: 'error' })
        this.$store.commit('jobPost/SET_PROFESSIONAL', null)
        this.$store.commit('jobUser/SET_JOB_USER', null)
      }
    }
  },
  mounted () {
    this.fetchAddressProvinces()
    this.checkCurrentPath(this.$route)
    // Update layoff status for professional only
    if (this.jobUser) {
      this.updateProfessionalStatus(this.jobUser.id)
    }
  }
}
</script>

<style scoped>
.main-content {
  min-height: 100vh;
  padding-bottom: 3rem;
}

.bottom-navigation {
  z-index: 10;
  height: auto;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
}

.menu-text {
  color: #00ACC1 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/jobPost/Index.vue